import { render, staticRenderFns } from "./RegistrationRequestChecklistItem.vue?vue&type=template&id=069ea566&scoped=true"
import script from "./RegistrationRequestChecklistItem.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./RegistrationRequestChecklistItem.vue?vue&type=style&index=0&id=069ea566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ea566",
  null
  
)

export default component.exports